const Loading = () => {
  return (
    <div className="flex min-h-[200px] items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="relative">
          <div className="border-primary h-10 w-10 animate-spin rounded-full border-3 border-t-transparent" />
          <div className="border-primary/20 absolute inset-0 rounded-full border-3" />
        </div>
        <p className="text-muted-foreground sr-only animate-pulse text-sm">
          Loading...
        </p>
      </div>
    </div>
  );
};

export default Loading;
